var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"container"},[_c('contact-form',{attrs:{"id":"form"}}),_c('contact-creds',{attrs:{"id":"creds"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }